export default __webpack_public_path__ + "static/media/leaf.083a45f2.png";